import React, { useEffect, useState } from 'react';
import './AboutUs.css';
import { Link } from 'react-router-dom';
import MainNavbar from "../MainNavbar";
import axios from 'axios';
import { GiPartyPopper, GiTrophy, GiTv, GiWorld } from 'react-icons/gi';
import { GiArchiveRegister, GiSmartphone, GiSettingsKnobs, GiCardExchange } from 'react-icons/gi';
import { GiTargetArrows, GiBinoculars } from 'react-icons/gi';
import { GiVineFlower, GiTeamIdea, GiDiamondRing } from "react-icons/gi";
import { MdVerifiedUser, MdSupportAgent } from "react-icons/md";
import { FaPeopleCarry } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";


const AboutUsSection = () => {
  const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [index, setIndex] = useState(0);
  const [topReviews, setTopReviews] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();

  const branches = [
    { name: "Chennai", address: "Gowrivakkam, Chennai" },
    { name: "Coimbatore", address: "Gandhipuram, Coimbatore" },
    { name: "Madurai", address: "Mattuthavani, Madurai" },
    { name: "Trichy", address: "Thillai Nagar, Tiruchirappalli" },
    { name: "Salem", address: "Junction Road, Salem" },
    { name: "Vellore", address: "Chathuvachari, Vellore" },
  ];




  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchGalleryImages = async () => {
      try {
        const response = await axios.get("https://back.varankal.com/api/success-stories");
        const allStories = response.data;

        // Filter only image-type stories
        const imagesOnly = allStories
          .filter((story) => story.fileType === "image")
          .slice(0, 4) // ✅ Take only the first 4 images
          .map((story) => story.fileUrl);

        setGalleryImages(imagesOnly);
      } catch (error) {
        console.error("Error fetching gallery images:", error);
      }
    };

    fetchGalleryImages();
  }, []);


  const fetchReviews = async () => {
    try {
      const response = await fetch("https://back.varankal.com/api/reviews");
      if (!response.ok) throw new Error("Failed to fetch reviews");
      const data = await response.json();

      const firstFive = data.slice(0, 5);
      setTopReviews(firstFive);

      // Calculate average from first 5 ratings
      const avg =
        firstFive.reduce((sum, r) => sum + r.rating, 0) / firstFive.length;

      // Multiply average by 2 to convert to out of 10 scale
      const avgOutOf10 = (avg * 2).toFixed(1);

      setAverageRating(avgOutOf10);
    } catch (err) {
      console.error("Failed to fetch reviews", err);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const steps = [
    {
      icon: <MdVerifiedUser size={40} color="#fa3380" />,
      title: "100% Verified Tamil Matrimonial Profiles",
      description: "All Varankal profiles are verified manually and digitally to ensure genuine and trustworthy matches."
    },
    {
      icon: <GiVineFlower size={40} color="#fa3380" />,
      title: "Respect for Every Culture & Community",
      description: "We value diversity and inclusiveness, connecting Tamil brides and grooms across all traditions."
    },
    {
      icon: <MdSupportAgent size={40} color="#fa3380" />,
      title: "Customer Support with Personal Care",
      description: "Our support team offers personal assistance to make your matchmaking experience smooth and pleasant."
    },
    {
      icon: <GiDiamondRing size={40} color="#fa3380" />,
      title: "Thousands of Successful Matches",
      description: "Join thousands of happy Tamil couples who found their life partners through Varankal Matrimony."
    }
  ];

  return (
    <>
      <MainNavbar />
      <section>
        <Helmet>
          <title>About Varankal.com | Trusted Tamil Matrimony Platform in Tamil Nadu</title>
          <meta
            name="description"
            content="Learn more about Varankal.com, a leading Tamil Matrimony platform connecting Tamil brides and grooms globally. Discover our mission, values, and success stories."
          />
          <meta
            name="keywords"
            content="About Tamil Matrimony, Varankal.com, Trusted Matrimony Tamil Nadu, Tamil Bride and Groom, Tamil Marriage Site, Tamil Matrimonial Service"
          />
        </Helmet>

        <section className="about-us-section">
          <div className="content-container">
            <div className="text-section">
              {/* <h1>
              Lovely Pair <span className="highlight">Matrimony.</span>

            </h1> */}
              <h1>💫 About Varankal</h1>

              <p className="quote">
                At Varankal.com, we believe that finding your life partner should be a journey filled with trust, comfort, and cultural connection.
                As one of Tamil Nadu’s most loved Tamil Matrimony Websites, Varankal was created to make matchmaking simpler, safer, and more meaningful.
              </p>
              {/* <div className="who-are-we">
              <h2>Who Are We?</h2>
              <p>
                At Lovely Pair Matrimony, we believe in the magic of true love and relationships. Our platform helps individuals find their perfect match based on shared values, interests, and goals. We are dedicated to making your journey towards finding love as smooth and delightful as possible. Join us today and start your journey toward everlasting happiness.
              </p>
            </div> */}
              <div className="rating-section">
                <div className="avatars">
                  {topReviews.map((review, i) => {
                    console.log("Image source:", review.image);
                    return (
                      <img
                        key={i}
                        src={review.image}
                        alt={review.user}
                        onError={(e) => (e.target.src = "https://via.placeholder.com/80")}
                      />
                    );
                  })}

                </div>
                <div className="stars">
                  {Array.from({ length: 5 }, (_, i) => (
                    <span key={i} className="star">
                      {i < Math.floor(averageRating / 2)
                        ? "★"
                        : i < averageRating / 2
                          ? "★" // Or use a half-star if available
                          : "☆"}
                    </span>
                  ))}
                  <span className="score">{averageRating} / 10</span>
                </div>


              </div>

            </div>
            <div className="image-section">
              <div className="video-section">
                <video controls autoPlay loop muted width="100%">
                  <source src="https://varankal.s3.us-east-1.amazonaws.com/varankal/1473785_People_Feelings_3840x2160.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>



            </div>
            <h4 className="video-caption">A journey of love, faith begins here</h4>
            <div className="divider-floral-text">
              <p>
                <span className="highlight-text">Two hearts</span> destined to meet,
                <span className="highlight-text">two souls</span> bound by faith,
                building a journey of love, respect, and lifelong companionship.
              </p>
            </div>
          </div>
        </section>


        <section className="create-biodata-section">
          <div className="mission-vision-achievements">
            <div className="side-section mission">
              <div className="icon-heading">
                <GiTargetArrows size={28} color="#400028" style={{ marginRight: '8px' }} />
                <h3>Our Mission</h3>
              </div>
              <p>To unite Tamil families globally through a trusted digital platform that celebrates tradition, emotion, and togetherness.</p>
            </div>

            {/* Center Column */}
            <div className="center-section achievements">
              <h2 className="highlight">Inspiring Connections, Building Futures</h2>
              <img
                src="https://png.pngtree.com/png-vector/20220727/ourmid/pngtree-floral-divider-ornament-png-image-png-image_6088796.png"
                alt="floral"
                className="floral-divider"
              />
              <div>
                <h4 className="section-title">OUR ACHIEVEMENTS</h4>
                <div className="achievements-grid">
                  <div className="achievement-card">
                    <div className="icon"><GiPartyPopper size={32} /></div>
                    <p>99+ Matches</p>
                  </div>
                  <div className="achievement-card">
                    <div className="icon"><GiTrophy size={32} /></div>
                    <p>95% Satisfaction</p>
                  </div>
                  <div className="achievement-card">
                    <div className="icon"><GiTv size={32} /></div>
                    <p>Media Featured</p>
                  </div>
                  <div className="achievement-card">
                    <div className="icon"><GiWorld size={32} /></div>
                    <p>20+ States</p>

                  </div>
                </div>
              </div>
            </div>


            <div className="side-section vision">
              <div className="icon-heading">
                <GiBinoculars size={28} color="#400028" style={{ marginRight: '8px' }} />
                <h3>Our Vision</h3>
              </div>
              <p>To become Tamil Nadu’s most reliable and respected Matrimony brand, known for love stories built on values, respect, and compatibility.</p>
            </div>

          </div>
        </section>



        <section className="how-it-works-section">
          <p className="subtitle">TRUSTED BY TAMIL FAMILIES</p>
          <h2>Why Families Trust Varankal</h2>

          <div className="card-container">
            {steps.map((step, index) => (
              <div className="step-card" key={index}>
                <div className="step-icon">{step.icon}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </section>


        <section className="retail-outlet-section">
          <div className="retail-outlet-container">
            <div className="retail-outlet-left">
              <h2>
                <span className="brand-title">Varankal</span>{" "}
                <span className="highlight-title">Retail Outlet</span>
              </h2>
              <p className="description">
                Visit your nearest Varankal store to get assistance on
              </p>

              <ul className="service-list">
                <li>
                  <div className="service-icon"><GiArchiveRegister size={24} /></div>
                  <span>Registering your profile</span>
                </li>
                <li>
                  <div className="service-icon"><GiSmartphone size={24} /></div>
                  <span>Using Varankalmatrimony</span>
                </li>
                <li>
                  <div className="service-icon"><GiSettingsKnobs size={24} /></div>
                  <span>Enhancing your profile and setting preferences</span>
                </li>
                <li>
                  <div className="service-icon"><GiCardExchange size={24} /></div>
                  <span>Making payments</span>
                </li>
              </ul>

            </div>

            <div className="retail-outlet-right">
              <img src="https://varankal.s3.us-east-1.amazonaws.com/varankal/lovely+pair.jpg" alt="Tamil Matrimony Outlet" />
            </div>
          </div>
          <div className="branch-youtube-wrapper">
            <div className="youtube-section">
              <h2 className="youtube-title">Watch Our Introduction</h2>
              <div className="youtube-iframe-wrapper">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/VIDEO_ID"
                  title="YouTube video"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div className="branch-list-section">
              <h2 className="branch-title">Our Branches</h2>
              <div className="branch-columns">
                {[0, 1].map((col) => (
                  <div className="branch-column" key={col}>
                    {branches.slice(col * 3, col * 3 + 3).map((branch, index) => {
                      const actualIndex = col * 3 + index;
                      return (
                        <div
                          key={actualIndex}
                          className={`branch-item ${openIndex === actualIndex ? "active" : ""}`}
                        >
                          <div className="branch-name" onClick={() => handleToggle(actualIndex)}>
                            {branch.name}
                            <span className={`arrow ${openIndex === actualIndex ? "up" : "down"}`}>
                              {openIndex === actualIndex ? "▲" : "▼"}
                            </span>
                          </div>
                          <div
                            className={`branch-address-wrapper ${openIndex === actualIndex ? "show" : ""}`}
                          >
                            <div className="branch-address">{branch.address}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>


          </div>


        </section>

        <section className="gallery-section">
          <div className="gallery-header">
            <h3 className="gallery-collection">Collection</h3>
            <h2 className="gallery-title">Photo gallery</h2>
            <img
              src="https://png.pngtree.com/png-vector/20220727/ourmid/pngtree-floral-divider-ornament-png-image-png-image_6088796.png"
              alt="floral"
              className="floral-divider"
            />
          </div>
          {/* <div className="gallery-footer">
            <button className="see-all-button">See All</button>
          </div> */}

          <div className="gallery-grid">
            {galleryImages.map((src, index) => (
              <div className="gallery-image-wrapper" key={index}>
                <img src={src} alt={`Wedding ${index + 1}`} className="gallery-image" />
              </div>
            ))}
          </div>



          {/* Optional decoration */}
          <img src="/images/leaf-left.png" alt="" className="leaf-left" />
          <img src="/images/leaf-right.png" alt="" className="leaf-right" />
        </section>

        <section>
          <div className="cta-container876">
            <div className="cta-content876">
              <div className="cta-text-container876">
                <div className="cta-text876">
                  <p className="cta-main-text876">Have any queries or need assistance?</p>
                  <p className="cta-sub-text876">We're here to help you on your journey to find the perfect match. <span className="cta-highlight">Feel free to reach out anytime!</span></p>
                </div>
              </div>

              <div className="cta-button-container">
                <Link to="/contactus" className="cta-button" style={{ textDecoration: 'none' }} >
                  Send a message

                </Link>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>

  );
};

export default AboutUsSection;






